import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { NgxSpinnerService } from "ngx-spinner";
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-novo-grupo',
  templateUrl: './novo-grupo.component.html',
  styleUrls: ['./novo-grupo.component.scss', '../../styles/estilo.padrao.scss']
})
export class NovoGrupoComponent implements OnInit {
  uid;
  grupoForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
  ) {
    this.uid = localStorage.getItem('uid')
  }

  ngOnInit(): void {
    this.grupoForm = this.formBuilder.group({
      nomeGrupo: ['', [Validators.required]],
    });
  }

  cadastrar() {

    this.spinner.show('default');

    if (this.grupoForm.valid) {
      this.usuarioService.getGrupoDuplicado(this.uid, this.f.nomeGrupo.value.trim()).pipe(take(1)).subscribe(async snap => {
        if (snap.length === 0) {
          try {
            const resp = await this.usuarioService.setGrupo(this.uid, this.f.nomeGrupo.value.trim());
            setTimeout(() => {
              this.spinner.hide('default');
              if (resp) {

                this.usuarioService.setLog("Cadastro de novo grupo: " + this.f.nomeGrupo.value.trim(), false, this.uid);

                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/consultar-grupo"], { queryParams: { IDGrupo: resp } }));
              } else {
                this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
                  this.router.navigate(["/pages/novo-grupo"]));
              }
            }, 2000);
          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro no cadastro de novo grupo: " + this.f.nomeGrupo.value.trim() + ' Erro: ' + e, null, this.uid);

            this.toastr.error('Erro ao cadastrar grupo!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
              this.router.navigate(["/pages/novo-grupo"]));
          }
        } else {
          this.toastr.error('Já existe um grupo cadastrado com este nome!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => this.spinner.hide('default'), 500);
        }
      });

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.grupoForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }

  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/novo-grupo"]));
  }

  // convenience getter for easy access to form fields
  get f() { return this.grupoForm.controls; }

}
